var _defs, _rect, _path, _path2, _path3, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResumiqLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 84,
    viewBox: "0 0 280 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "resumiq-bg",
    x1: 10,
    y1: 8,
    x2: 68,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2563EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F172A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resumiq-page",
    x1: 22,
    y1: 15,
    x2: 49,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resumiq-tick",
    x1: 25,
    y1: 42,
    x2: 54,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22C55E"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 72,
    height: 72,
    rx: 20,
    fill: "url(#resumiq-bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 17C21 15.8954 21.8954 15 23 15H45L58 28V53C58 56.3137 55.3137 59 52 59H23C19.6863 59 17 56.3137 17 53V21C17 18.7909 18.7909 17 21 17Z",
    fill: "url(#resumiq-page)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15L58 28H48C46.3431 28 45 26.6569 45 25V15Z",
    fill: "#BFDBFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42L34 52L55 30",
    stroke: "url(#resumiq-tick)",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 50,
    fill: "currentColor",
    fontFamily: "Inter, Arial, Helvetica, sans-serif",
    fontSize: 34,
    fontWeight: 800,
    letterSpacing: -0.8
  }, "\n    ResumIQ\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumiqLogo);
export default __webpack_public_path__ + "static/media/resumiq-logo.70ee3218c855789dbae98bdd06773bb3.svg";
export { ForwardRef as ReactComponent };